import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import "../App.css";
import DatePicker from "rsuite/DatePicker";
import "rsuite/DatePicker/styles/index.css";
import { DotLoader } from "react-spinners";

function FormOne({ GetToNextPage }) {
  const [formContact, setFormContact] = useState([]);
  const [fullName, setFullname] = useState(
    formContact ? formContact.fullName : ""
  );
  const [email, setEmail] = useState(formContact ? formContact.email : "");
  const [phone, setPhone] = useState(formContact ? formContact.phone : "");
  const [checkIn, setCheckIn] = useState(
    formContact ? new Date(formContact.checkIn) : ""
  );
  const [checkOut, setCheckOut] = useState(
    formContact ? new Date(formContact.checkOut) : ""
  );
  const [message, setMessage] = useState(
    formContact ? formContact.message : ""
  );
  const [validate, setValidate] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("ClientData"))) {
      setFormContact(JSON.parse(localStorage.getItem("ClientData")));
    }
  }, []);

  const ValidateForm = () => {
    setLoading(true);
    if (fullName === "") {
      setValidate("fullName");
      setLoading(false);
    } else if (email === "") {
      setValidate("email");
      setLoading(false);
    } else if (phone === "") {
      setValidate("phone");
      setLoading(false);
    } else if (checkIn === "") {
      setValidate("checkIn");
      setLoading(false);
    } else if (checkOut === "") {
      setValidate("checkOut");
      setLoading(false);
    } else {
      const FormData = {
        fullName: fullName,
        email: email,
        phone: phone,
        checkIn: checkIn,
        checkOut: checkOut,
        message: message ? message : "",
      };
      localStorage.setItem("ClientData", JSON.stringify(FormData));
      setTimeout(() => {
        setLoading(false);
        GetToNextPage(2);
      }, 2000);
      console.log("form is clear for submition");
    }
  };

  //console.log(validate);

  return (
    <div>
      <Col xxl={8} className="Left_Container">
        {loading && (
          <div className="Loading_Overlay">
            <div className="Loading_Box">
              <DotLoader
                color={"#fff"}
                loading={loading}
                //cssOverride={override}
                size={50}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
              <span>SUBMITING</span>
            </div>
          </div>
        )}
        <div className="Header_Box">
          <h4 className="Header_Text">GUEST INFORMATION</h4>
        </div>
        <div className="Form_Container">
          <Form className="Form_Doc">
            <Form.Group className="mb-2 form_input" controlId="formBasicEmail">
              <Form.Label className="Input_label">Full Name</Form.Label>
              <Form.Control
                type="text"
                size="lg"
                autocomplete="name"
                defaultValue={fullName}
                onChange={(e) => setFullname(e.target.value)}
                placeholder="Enter Full Name"
              />
              {validate === "fullName" && (
                <span className="Error_Text">* This field is mandatory!</span>
              )}
            </Form.Group>
            <Row>
              <Col>
                <Form.Group
                  className="mb-2 form_input"
                  controlId="formBasicEmail"
                >
                  <Form.Label className="Input_label">Email</Form.Label>
                  <Form.Control
                    size="lg"
                    defaultValue={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="yourname@company.com"
                  />
                  {validate === "email" && (
                    <span className="Error_Text">
                      * This field is mandatory!
                    </span>
                  )}
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  className="mb-2 form_input"
                  controlId="formBasicEmail"
                >
                  <Form.Label className="Input_label">Phone Number</Form.Label>
                  <Form.Control
                    size="lg"
                    defaultValue={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    autocomplete="tel"
                    type="number"
                    placeholder="+41 758 8598 9"
                  />
                  {validate === "phone" && (
                    <span className="Error_Text">
                      * This field is mandatory!
                    </span>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group
                  className="mb-2 form_input"
                  controlId="formBasicEmail"
                >
                  <Form.Label className="Input_label">Check In Date</Form.Label>
                  <DatePicker
                    defaultValue={checkIn}
                    size="lg"
                    onChange={(date) => setCheckIn(date)}
                  />
                  {validate === "checkIn" && (
                    <span className="Error_Text">
                      * This field is mandatory!
                    </span>
                  )}
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  className="mb-2 form_input"
                  controlId="formBasicEmail"
                >
                  <Form.Label className="Input_label">
                    Check Out Date
                  </Form.Label>
                  <DatePicker
                    size="lg"
                    defaultValue={checkOut}
                    onChange={(date) => setCheckOut(date)}
                  />
                  {validate === "checkOut" && (
                    <span className="Error_Text">
                      * This field is mandatory!
                    </span>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-2 form_input" controlId="formBasicEmail">
              <Form.Label className="Input_label">Message</Form.Label>
              <Form.Control
                as="textarea"
                defaultValue={message}
                rows={3}
                onChange={(e) => setMessage(e.target.value)}
              />
            </Form.Group>

            {/* <Button variant="primary" type="submit">
        Submit
      </Button> */}
          </Form>
        </div>
        <div className="Form_Btn_Box">
          <Button
            className="Submit_Btn"
            variant="primary"
            onClick={ValidateForm}
          >
            SUBMIT & GO NEXT
          </Button>
        </div>
      </Col>
    </div>
  );
}

export default FormOne;
